export class InvestigationApproval {
  public investigationId!: string;
  public investigationNumber!: string;
  public investigationTypeName!: string;
  public statusName!: string;
  public statusDisplayName!: string;
  public statusColor!: string;
  public priorityCode!: string;
  public dueDate!: Date | null;
  public createdOn!: Date;
}
